<button mat-menu-item
  (click)="inviteUsers()"
  class="invite-users-btn">
  <span translate="invite-users"></span>
</button>
<button mat-menu-item
  (click)="manageUsers()"
  class="manage-users-btn">
  <span translate="course-menu_manage-users"></span>
</button>
@if (userService.currentUser.is_root_user) {
  <button mat-menu-item
    (click)="openAccountAdminSettings()"
    class="account-admin-btn">
    <span translate="group-menu-dropdown-platform-admin-account-settings"></span>
  </button>
}
@if (userService.currentUser.is_root_owner) {
  <button mat-menu-item
    (click)="deleteAccount()"
    class="delete-account-btn">
    <span translate="course-menu_delete-account"></span>
  </button>
}
